interface RequestConfig {
  baseUrl: string;
  socketUrl: string;
  socketPath: string;
  slackUrl: string;
  exchangeBaseUrl: string;
}

let requestConfig: RequestConfig = {
  baseUrl: "https://api.zania.app/frontend/dev",
  socketUrl: "wss://api.zania.app",
  slackUrl: "https://api.zania.app/slack-bot-staging/v0/slack/install",
  socketPath: "/internal/dev/socket/",
  exchangeBaseUrl: "https://api.zania.app/exchange/dev",
};

switch (import.meta.env.MODE) {
  case "demo": {
    requestConfig = {
      baseUrl: "https://api.zania.app/frontend/staging",
      socketUrl: "wss://api.zania.app",
      slackUrl: "https://api.zania.app/slack-bot-staging/v0/slack/install",
      socketPath: "/internal/staging/socket/",
      exchangeBaseUrl: "https://api.zania.app/exchange/staging",
    };
    break;
  }
  case "production": {
    requestConfig = {
      baseUrl: "https://api.zania.app/frontend",
      socketUrl: "wss://api.zania.app",
      slackUrl: "https://api.zania.app/slack-bot/v0/slack/install",
      socketPath: "/internal/socket/",
      exchangeBaseUrl: "https://api.zania.app/exchange",
    };
    break;
  }
  case "staging": {
    requestConfig = {
      baseUrl: "https://api.zania.app/frontend/staging",
      socketUrl: "wss://api.zania.app",
      slackUrl: "https://api.zania.app/slack-bot-staging/v0/slack/install",
      socketPath: "/internal/staging/socket/",
      exchangeBaseUrl: "https://api.zania.app/exchange/staging",
    };
    break;
  }
  case "development": {
    const devApiBase = import.meta.env.DEV ? "/api" : "https://api.zania.app";
    requestConfig = {
      baseUrl: `${devApiBase}/frontend/dev`,
      socketUrl: "wss://api.zania.app",
      slackUrl: "https://api.zania.app/slack-bot-staging/v0/slack/install",
      socketPath: "/internal/dev/socket/",
      exchangeBaseUrl: `${devApiBase}/exchange/dev`,
    };
    break;
  }
  case "localhost": {
    requestConfig = {
      baseUrl: "http://localhost:8000",
      socketUrl: "ws://localhost:8000",
      slackUrl: "http://localhost:8000/slack-bot-staging/v0/slack/install",
      socketPath: "",
      exchangeBaseUrl: "https://api.zania.app/exchange/dev",
    };
    break;
  }
}

export default requestConfig;
